import './scss/template-main.scss'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { cmsService } from './common/services/cms.service'
import { initServices } from './common/services/init'
import { init } from './init'

window.loadMs = Date.now()

// Initialize the CMS services
initServices()

cmsService.initialize().then(
    occConfigurationApi => {
        /**
         * Avoid placing any before-render scripts into this function.
         * Instead, run them in the below `init()` function to allow parity in automated test via storybook.
         */

        init(occConfigurationApi)

        const rootDiv = document.getElementById('root')
        if (rootDiv) {
            const root = createRoot(rootDiv)
            root.render(createElement(App))
        }
    },
    _ => {}
)
